import { CheckCircle } from '@emotion-icons/bootstrap';
import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { TEMPLATE_EXAMPLES } from '~/constants/templates';
import * as Styles from './styles';
import { ISectionProps } from './types';
import styled from '@emotion/styled';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const TemplateWrapper = styled.div`
  border: 1px solid #141414;
  width: 188px;
  height: 266px;
  min-width: 188px;
  min-height: 266px;
  max-width: 188px;
  max-height: 266px;
  border-radius: 4px;
  margin-right: 40px;

  > img {
    border-radius: 4px;
  }
`;

const SelectedTemplate = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 2px;
  background: linear-gradient(0deg, rgba(26, 30, 62, 1) 0%, rgba(255, 255, 255, 0.4) 100%);

  > p {
    color: var(--white);
    font-weight: 700;
    letter-spacing: 0.5rem;
    margin-bottom: 1rem;
  }
`;

const TemplateSection = ({ business, onChange }: ISectionProps) => {
  const selectedTemplate = business.template_id;
  const isDesktop = useIsDesktop();

  return (
    <Styles.Section>
      <Styles.SectionDesc>
        <Text className={isDesktop ? 'bold' : ''} size={isDesktop ? 'sm' : 'ssmd'}>
          Invoice Template
        </Text>
        <Gap t={4} />
        <Text size="xs" variant="neutral">
          Choose your default invoice template from our collection of professional designs
        </Text>
      </Styles.SectionDesc>
      <Gap r={40} />

      <div className={'d-flex has-x-scroll'}>
        {TEMPLATE_EXAMPLES.map(eachTemplate => {
          return (
            <TemplateWrapper
              key={eachTemplate.id}
              className={`cursor-pointer pos-r center`}
              onClick={() => {
                onChange({ template_id: eachTemplate.id });
              }}
            >
              <img src={eachTemplate.link} alt={eachTemplate.id} />
              {selectedTemplate === eachTemplate.id && (
                <SelectedTemplate className={`pos-a v-center`}>
                  <CheckCircle size={36} color="var(--white)" />
                </SelectedTemplate>
              )}
            </TemplateWrapper>
          );
        })}
      </div>
    </Styles.Section>
  );
};

export default TemplateSection;
